'use client';

import React from 'react';

interface BlogCommentsProps {
  postId: string;
}

export default function BlogComments({ postId }: BlogCommentsProps) {
  return (
    <section className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-xl font-semibold text-foreground mb-2">Comments</h3>
      <p className="text-sm text-muted-foreground">
        Comments are temporarily unavailable. Post ID: {postId}
      </p>
    </section>
  );
}